import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, useTheme } from "@mui/material";
import { ImageWithLockedAspectRatio } from "./ImageWithLockedAspectRatio";
const styles = {
    iconButton: {
        color: "white",
        backgroundColor: "black",
        opacity: 0.6,
        "&:hover": {
            color: "white",
            backgroundColor: "rgba(0, 0, 0, 0.75)",
        },
    },
    buttonContainer: {
        position: "absolute",
        top: (theme) => theme.spacing(1),
        right: (theme) => theme.spacing(1),
    },
};
export const ImageWithDismiss = ({ imageUrl, onDismiss, disabled }) => {
    const { spacing } = useTheme();
    return (_jsxs(Box, { position: "relative", children: [_jsx(Box, { children: _jsx(ImageWithLockedAspectRatio, { imageUrl: imageUrl, borderRadius: spacing(0.5) }) }), _jsx(Box, { sx: styles.buttonContainer, children: _jsx(IconButton, { disabled: disabled, sx: styles.iconButton, onClick: onDismiss, size: "small", children: _jsx(CloseIcon, { fontSize: "small" }) }) })] }));
};
//# sourceMappingURL=ImageWithDismiss.js.map